import express, { Router } from 'express';

import * as emailValidation from '@/modules/communication/email/email.validation';
import * as emailController from '@/modules/communication/email/email.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(),
    validateMiddleware(emailValidation.getEmail),
    emailController.getEmail,
  )
 

router
  .route('/:templateId')
  .patch(
    userAuthAndCheckPermissions(),
    validateMiddleware(emailValidation.updateTemplate),
    emailController.updateTemplate,
  );

export default router;
